import React, {  } from 'react';
import classNames from "classnames";

import style  from './style.module.css';
import typ from "design-v2/globals/typography.module.css";
import {ITagListItem} from './types';
import { Checkbox } from '@material-ui/core';
import TagPanelIcon from './TagPanelIcon';



const TagListItem = (props: ITagListItem) => {
  const {
    tag,
    state,
  } = props;
  const {
    name,
  } = tag;
  const {
    selected,
  } = state;

  return (
    <div className={style.tagListItem}>
      <div
        className={classNames({
          [style.tagListItemContainer]: true,
          [style.tagListItemContainerSelected]: selected,
        })}
      >
        <div className={style.contentContainer}>
          <div className={style.iconContainer}>
            <TagPanelIcon tag={tag} />
          </div>
          <div className={style.titleContainer}>
            <span className={classNames({
              [style.text]: true,
              [typ.typSize2]: true,
              [typ.typReg]: true,
            })}>{name}</span>
          </div>
          <div className={style.checkContainer}>
            <Checkbox
              data-testid={'test-id-checkbox-'+ name}
              className={style.checkbox}
              checked={selected}
              color="primary"
            />
          </div>
        </div>
        <div className={style.borderContainer}>
        </div>
      </div>
    </div>
  );
}
export default TagListItem;
